import { render, staticRenderFns } from "./AddProvenanceToList.vue?vue&type=template&id=56dfbe86&"
import script from "./AddProvenanceToList.vue?vue&type=script&lang=js&"
export * from "./AddProvenanceToList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports